<div class="container w-[100%]">
  <!-- *ngIf="showSearchInput" -->
  <input
    id="searchInput"
    type="text"
    class="mt-[6px] pl-[12px] section-input"
    placeholder="Search for a location"
    style="
      position: absolute;
      left: 200px;
      top: 0px;
      width: 35rem;
      height: 45px;
      /* border-radius: 12px; */
      font-size: small;
    "
  />

  <div id="map" class="w-full h-96 border-2 border-gray-300"></div>
</div>
